import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-banner-promo',
    templateUrl: './banner-promo.component.html',
    styleUrls: ['./banner-promo.component.css'],
    standalone: false
})
export class BannerPromoComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal,
    public dialogRef: MatDialogRef<BannerPromoComponent>) { }

  ngOnInit(): void {
  }

}
